module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "header0901",
      "epub:type": "chapter",
      "id": "ch09",
      "role": "doc-chapter"
    }
  }, [_c('header', {
    attrs: {
      "id": "header0901"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiseneca0005#rch09"
    }
  }, [_vm._v("Letter 9")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Friendship and self-sufficiency")]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("From Seneca to Lucilius")]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("Greetings")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p1",
      "id": "c9p1r",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])])]), _vm._v(" You are eager to know whether Epicurus was justified in the criticism expressed in one of his letters* against those who say that the wise person is self-sufficient and for this reason has no need of a friend.* It is a charge made by him against Stilpo* and others who say that the highest good is an impassive "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "18",
      "id": "p18",
      "role": "doc-pagebreak"
    }
  }), _vm._v("mind. "), _c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p2",
      "id": "c9p2r",
      "role": "doc-noteref"
    }
  }, [_vm._v("2")])])]), _vm._v(" (If we choose to express the Greek word "), _c('i', [_vm._v("apatheia")]), _vm._v(" quickly in one word and say "), _c('i', [_vm._v("impatientia")]), _vm._v(", we cannot help but create ambiguity, for "), _c('i', [_vm._v("impatientia")]), _vm._v(" can also be understood in the opposite sense to what we intend: we mean by it a person who refuses to feel any misfortune, but it will be taken to refer to one who cannot bear any misfortune.* Consider, then, whether it might not be better to speak of the invulnerable mind or the mind set beyond all suffering.) "), _c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p3",
      "id": "c9p3r",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])])]), _vm._v(" Our position is different from theirs in that our wise person conquers all adversities, but still feels them; theirs does not even feel them.* That the sage is self-sufficient is a point held in common between us; yet even though he is content with himself, he still wishes to have a friend, a neighbor, a companion.*")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p4",
      "id": "c9p4r",
      "role": "doc-noteref"
    }
  }, [_vm._v("4")])])]), _vm._v(" To see how self-sufficient he is, consider this: there are times when he is satisfied with just part of himself. If his hand were cut off in battle or amputated due to gangrene; if an accident cost him an eye, or even both eyes, the remaining parts of himself would be sufficient for him; he will be as happy with his body diminished as he was with it whole. Still, although he does not feel the want of the missing limbs, he would prefer that they not be missing.* "), _c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p5",
      "id": "c9p5r",
      "role": "doc-noteref"
    }
  }, [_vm._v("5")])])]), _vm._v(" He is self-sufficient, not in that he wants to be without a friend, but in that he is able to—by which I mean that he bears the loss with equanimity. But in truth he will never be without a friend, for it rests with him how quickly he gets a replacement. Just as Phidias, if he should lose one of his statues, would immediately make another, so this artist at friend-making will substitute another in place of the one who is lost.*")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p6",
      "id": "c9p6r",
      "role": "doc-noteref"
    }
  }, [_vm._v("6")])])]), _vm._v(" Are you asking how he will make a friend so quickly? I will tell you, provided you agree that my debt is paid herewith, and the account is cleared as concerns this letter. Hecaton says,")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "19",
      "id": "p19",
      "role": "doc-pagebreak"
    }
  }), _vm._v("I will show you a love charm without drugs, without herbs, without any witch’s incantation: love, if you would be loved.*")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Moreover, there is great pleasure to be had not only from the practice of an old and established friendship but also from the initiation and acquisition of a new one. "), _c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p7",
      "id": "c9p7r",
      "role": "doc-noteref"
    }
  }, [_vm._v("7")])])]), _vm._v(" The difference between making a friend and having made one is the same as between sowing and reaping. The philosopher Attalus used to say that it is more pleasant to make a friend than to have a friend, “just as it is more pleasurable for an artist to paint a picture than to have painted one.”* That focused concentration on one’s work is deeply enjoyable in itself; the pleasure one has in the finished product after the work is done does not equal it. Now, the artist is enjoying the result of his art; while he was painting, he was enjoying the art itself. Children are more rewarding when fully grown, but sweeter in infancy.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p8",
      "id": "c9p8r",
      "role": "doc-noteref"
    }
  }, [_vm._v("8")])])]), _vm._v(" Now let’s return to our stated thesis. Even if the sage is self-sufficient, he still wants to have a friend. If for no other reason, he wants to keep such a great virtue from going unused. His motive is not what Epicurus says in this very letter, “to have someone to sit beside him in illness, or to assist him in imprisonment or in need.”* Instead, it is to have someone whom he himself may sit beside in illness, whom he himself may liberate from an enemy’s capture. He who looks to himself, and comes to friendship for that reason, thinks amiss. As he began, so will he end: he made the friend to gain his assistance in captivity, but he himself will be gone at the first clink of a chain. "), _c('span', {
    staticClass: "pnum"
  }, [_vm._v("9")]), _vm._v(" These are what are commonly called fair-weather friendships. A friend taken on because of his utility will be pleasing only as long as he is useful. That is why those who "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "20",
      "id": "p20",
      "role": "doc-pagebreak"
    }
  }), _vm._v("are in prosperity have a crowd of friends hanging about, while those who have had a fall are deserted: friends run away just when they have the opportunity to prove their friendship. That is why there are so many terrible stories of people abandoning their friends, or even betraying them, through fear.")]), _vm._v(" "), _c('p', [_vm._v("Beginnings and endings must agree. He who begins being a friend for the sake of expediency will also stop for the sake of expediency. Some amount of money will be chosen over the friendship if that friendship is valued for anything besides itself. "), _c('span', {
    staticClass: "pnum"
  }, [_vm._v("10")]), _vm._v(" “Why make a friend?” To have someone I can die for, someone I can accompany into exile, someone whose life I can save, even by laying down my own. What you describe is a business deal, not a friendship, for it looks to its own advantage; it thinks in terms of results.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p11",
      "id": "c9p11r",
      "role": "doc-noteref"
    }
  }, [_vm._v("11")])])]), _vm._v(" No one doubts that the feelings of lovers bear some resemblance to friendship. One could even say that love is a friendship gone mad. So does anyone fall in love in order to make a profit? Or for the sake of ambition, or for glory? Love all by itself, caring nothing for other objectives, inflames the mind with desire for the other’s beauty, and hopes the affection will be returned. What shall we conclude? Does a base emotion arise from a more honorable origin?*")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_vm._v("12")]), _vm._v(" You say, “Our question is not whether friendship is choiceworthy in itself.” On the contrary, that is the point that needs most of all to be established; for if friendship is choiceworthy in itself, then it is possible for one who is self-sufficient to pursue it. “In what way, then, does he pursue it?” As one does any deeply beautiful thing, not drawn by profit, and not cowed by the vagaries of fortune. The grandeur of friendship is diminished when one makes a friend just to better one’s lot.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_vm._v("13")]), _vm._v(" “The wise person is self-sufficient.” My dear Lucilius, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "21",
      "id": "p21",
      "role": "doc-pagebreak"
    }
  }), _vm._v("many people misinterpret this. They pull the sage in on every side, driving him inside his own skin. The fact is, one has to make some distinctions as to what that assertion means and how far it extends. The wise person is self-sufficient as concerns living a good life, but not as concerns living in general. For the latter, there are many things he requires; for the former, only a sound and upright mind that rises superior to fortune.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p14",
      "id": "c9p14r",
      "role": "doc-noteref"
    }
  }, [_vm._v("14")])])]), _vm._v(" Let me tell you Chrysippus’s distinction as well. He says that even though the wise person lacks nothing, he still has a use for many things. “By contrast, there is nothing the foolish person has a use for—since he does not know how to use things—and yet he lacks everything.” The wise person has a use for hands and eyes and many other things that are needed for everyday living, and yet lacks nothing. For “lack” implies “need,” and the wise person is not in need of anything.*")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_vm._v("15")]), _vm._v(" Therefore, even though he is self-sufficient, he does have a use for friends, and wants to have as many as possible. But he does not want them in order to live a good life. He will do that even without friends, for the highest good does not look for instruments outside itself. It is raised in one’s own home, and is complete all by itself. If you seek any part of it from outside, it begins to be subject to fortune.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p16",
      "id": "c9p16r",
      "role": "doc-noteref"
    }
  }, [_vm._v("16")])])]), _vm._v(" “But what sort of life will the wise man have if he is left without friends when in captivity, or stranded in some foreign country, or delayed on some long voyage, or cast away on a desert island?” The kind Jupiter has at that time when the world is dissolved and all gods are mingled into one, when nature ceases its operations for a while and he devotes himself to his own thoughts, and rests in himself. What the sage does is something like that: he retreats into himself and is his own company.*")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "22",
      "id": "p22",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p17",
      "id": "c9p17r",
      "role": "doc-noteref"
    }
  }, [_vm._v("17")])])]), _vm._v(" Still, as long as he has the option of arranging his affairs to suit his own preferences, he is self-sufficient, and yet takes a wife; self-sufficient, and yet raises children; self-sufficient, and yet would not live at all if it meant living without other people. What brings him to friendship is not his own expediency but a natural instinct. For just as we innately find certain other things appealing, so it is with friendship. Just as it is inherent in us to shun solitude and seek companionship—just as nature attaches human beings to one another—so also is there an innate prompting to pursue friendships.*")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p18",
      "id": "c9p18r",
      "role": "doc-noteref"
    }
  }, [_vm._v("18")])])]), _vm._v(" All the same, even though the wise person loves his friends very deeply, putting them on a par with himself or, often, ahead of himself, he nonetheless considers every good to be bounded within himself, and will give the same opinion as Stilpo did—that Stilpo who is criticized in Epicurus’s letter. Stilpo’s homeland fell to invaders; his children were lost, his wife was lost, and he alone survived the destruction of his people. Yet he emerged happy; and when Demetrius, who was called Poliorcetes, or “City-Sacker,” asked him whether he had lost anything, he replied, “All my goods are with me.”* "), _c('span', {
    staticClass: "pnum"
  }, [_vm._v("19")]), _vm._v(" Here is a brave man, and a tough one: he conquered even his enemy’s conquest. “I have lost nothing,” he said, and made Poliorcetes doubt whether he had really conquered at all. “All my goods are with me”: justice, courage, prudence, and this in itself, the ability to think that nothing is good which can be taken away. We are amazed that some animals can pass through fire without damage to their bodies. How much more amazing is this man, who escaped fire, sword, and devastation, not only without injury but even without loss! You see how much easier it is to defeat an entire people than a single man? Stilpo’s saying is "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "23",
      "id": "p23",
      "role": "doc-pagebreak"
    }
  }), _vm._v("shared by the Stoic: he too carries his goods intact through the devastation of cities, for he is self-sufficient. It is by that limit that he defines his prosperity.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p20",
      "id": "c9p20r",
      "role": "doc-noteref"
    }
  }, [_vm._v("20")])])]), _vm._v(" But you shouldn’t think that we are the only ones to speak such noble words. Epicurus himself, for all his criticism of Stilpo, delivered a saying similar to his. Give me credit for it, even though I have already paid up for today. He says,")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Anyone who does not think that what he has is plenty, is miserable, even if he is ruler of the entire world.*")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Or, if you think this a better way of expressing it (for our service should be given to thoughts, not words): “Wretched is he who does not believe himself supremely happy, though he rule the world.” "), _c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c9p21",
      "id": "c9p21r",
      "role": "doc-noteref"
    }
  }, [_vm._v("21")])])]), _vm._v(" But to show you that these are widely shared opinions, no doubt dictated by nature, a comic poet supplies the following:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("No one is happy who does not believe himself to be.*")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("If you think your circumstances are bad, then does it matter what they are really like?")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_vm._v("22")]), _vm._v(" “But look,” you say. “What about So-and-So, with his tainted money, or So-and-So, master of many and slave of many more? If one of them claims to have a good life, does his opinion make it so?” It is not what he says that counts, but what he thinks—and not what he thinks on any one day, either, but what he thinks over time. Anyway, you need not worry about so great a prize being awarded to one who does not deserve it. Only the wise man is satisfied with what he has: all the foolish are disgusted with themselves, and suffer accordingly.")]), _vm._v(" "), _c('p', [_vm._v("Farewell.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5408942","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-seneca-0015.vue
// module id = 96
// module chunks = 0